import { Inject, Injectable } from '@angular/core';
import { Angulartics2, Angulartics2GoogleTagManager } from 'angulartics2';

import { DOCUMENT } from '@angular/common';
import { AnalyticsEventsService } from './analytics-events.service';
import { ClarityService } from './analytics/clarity.service';
import { ConsoleAnalyticsService } from './analytics/console-analytics.service';
import { FreshChatService } from './analytics/freshchat.service';
import { PostHogService } from './analytics/posthog.service';
import { CurrentUserService } from './current-user.service';

export interface Analytics {
  startTracking();
}

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService implements Analytics {
  constructor(
    currentUser: CurrentUserService,
    angulartics2: Angulartics2,
    private events: AnalyticsEventsService,
    private gtm: Angulartics2GoogleTagManager, // 🪦 Google / Universal Analytics
    private ca: ConsoleAnalyticsService,
    private clarity: ClarityService,
    private freshchat: FreshChatService,
    private postHog: PostHogService,
    @Inject(DOCUMENT) private document: Document
  ) {
    currentUser.user$.subscribe((user) => {
      angulartics2.setUsername.next(String(user.id));
      angulartics2.setUserProperties.next({ dimension1: user.id });
    });
  }

  startTracking() {
    // don't need to worry about unsubscribing from this
    this.events.events$.subscribe((event) => this.document.dispatchEvent(event));

    this.gtm.startTracking();
    this.ca.startTracking();
    this.clarity.startTracking();
    this.freshchat.startTracking();
    this.postHog.startTracking();
  }
}
